module.exports = __webpack_public_path__ + "static/img/superior-bg.ae72c504.png";